import React from 'react';
import { useLocation } from 'react-router-dom';
import { getStoredUser } from '../utils/auth';
import {
  isPlatformAdmin,
  isSuperVisor,
  isAssistantSuperVisor,
  isProjectManager,
} from '../utils/roles';
import { SuperAdminDashboard } from '../components/SuperAdminDashboard';
import { AdminDashboard } from '../components/AdminDashboard';
import {
  SuperVisorDashboard,
  AssistantSuperVisorDashboard,
  ProjectManagerDashboard,
} from '../components/SafetyRoleDashboard';
import UserSafetyDashboard from './Dashboard';

export default function DashboardRouter() {
  const location = useLocation();
  const user = location.state?.user || getStoredUser();

  if (isPlatformAdmin(user?.role)) {
    return <SuperAdminDashboard user={user} />;
  }

  if (isSuperVisor(user?.role)) {
    return <SuperVisorDashboard user={user} />;
  }

  if (isAssistantSuperVisor(user?.role)) {
    return <AssistantSuperVisorDashboard user={user} />;
  }

  if (isProjectManager(user?.role)) {
    return <ProjectManagerDashboard user={user} />;
  }

  if (user?.role === 'admin') {
    return <AdminDashboard user={user} />;
  }

  return <UserSafetyDashboard />;
}
